const cards = [
  {
    title: '不可错过的科幻电影TOP20',
    desc: '从硬核科幻到太空歌剧，精选二十部改变影史的科幻经典之作，每一部都值得反复观看。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20with%20futuristic%20space%20nebula%20and%20warm%20golden%20light%20beams%2C%20deep%20crimson%20accents%2C%20luxurious%20theater%20atmosphere%2C%20no%20text%2C%20elegant%20composition&width=800&height=500&seq=cards-01&orientation=landscape',
    tag: '影单推荐',
  },
  {
    title: '悬疑片爱好者的终极片单',
    desc: '反转不断、烧脑到最后一刻的悬疑佳作合集，从经典推理到心理惊悚，满足你的推理欲望。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20with%20mysterious%20shadowy%20figure%20silhouette%20and%20warm%20golden%20light%2C%20deep%20crimson%20accents%2C%20theater%20atmosphere%2C%20no%20text%2C%20elegant%20moody&width=800&height=500&seq=cards-02&orientation=landscape',
    tag: '类型精选',
  },
  {
    title: '2026年最值得期待的十部大片',
    desc: '从续集回归到全新IP，展望本年度即将上映的热门大片，提前锁定你的年度观影清单。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20with%20countdown%20and%20calendar%20motifs%20in%20warm%20golden%20light%2C%20deep%20crimson%20accents%2C%20theater%20atmosphere%2C%20no%20text%2C%20elegant&width=800&height=500&seq=cards-03&orientation=landscape',
    tag: '前瞻预告',
  },
  {
    title: '国产现实主义电影推荐',
    desc: '聚焦社会议题、直击人心的国产现实主义佳作，以真实故事打动观众，展现中国电影的深度。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20with%20urban%20streetscape%20silhouette%20in%20warm%20golden%20light%2C%20deep%20crimson%20accents%2C%20theater%20atmosphere%2C%20no%20text%2C%20realistic%20mood&width=800&height=500&seq=cards-04&orientation=landscape',
    tag: '深度推荐',
  },
  {
    title: '动漫电影：不止是给孩子看的',
    desc: '精选适合全年龄段的高质量动画电影，无论是画面、配乐还是故事内核，都是顶级水准。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20with%20colorful%20animated%20style%20elements%20in%20warm%20golden%20light%2C%20deep%20crimson%20accents%2C%20theater%20atmosphere%2C%20no%20text%2C%20vibrant&width=800&height=500&seq=cards-05&orientation=landscape',
    tag: '合家欢',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">精选内容</h2>
          <p className="text-foreground-500 text-sm mt-2">为你精心整理的观影推荐</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {cards.map((item) => (
            <div
              key={item.title}
              className="group flex flex-col bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2 px-2.5 py-1 bg-background-50/80 backdrop-blur-sm rounded-full text-[10px] text-foreground-300">
                  {item.tag}
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-foreground-600 text-xs leading-relaxed flex-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}